<template>
  <el-container class="app-wrapper">
    <!-- 顶部导航 -->
    <el-header height="60px" class="app-header">
      <div class="header-left">
        <div class="logo" @click="_toIndex">{{ systemInfo.systemSimpleTitle }}</div>
        <el-menu mode="horizontal" :default-active="activeMenu" class="header-menu" background-color="#003434"
          text-color="rgba(255,255,255,0.85)" active-text-color="#ffffff">
          <template v-for="(item, index) in catalogs">
            <el-menu-item :index="item.caId" v-if="!item.privId || hasPrivilege(item.privId)" :key="index"
              @click="_changeMenuCatalog(item, true)">{{ item.name }}</el-menu-item>
          </template>
        </el-menu>
      </div>
      <div class="header-right">
        <el-dropdown @command="changeCommunity" v-if="storeInfo.storeTypeCd == '800900000003'" class="margin-right">
          <span class="user-info">
            {{ curCommunityName }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="c" v-for="(c, index) in communitys" :key="index">{{ c.name }}</el-dropdown-item>
            <el-dropdown-item command="moreCommunity" class="moreCommunity">{{ $t('layout.moreCommunity')
              }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown @command="handleCommand">
          <span class="user-info">
            {{ username }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">{{ $t('layout.logout') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span class="margin-left">{{ systemInfo.version }}</span>

      </div>
    </el-header>

    <el-container>
      <!-- 左侧菜单 width="64px"-->
      <el-aside class="app-aside" width="80">
        <div class="vc-menu flex justify-start" id="menu-nav">
          <div class="vc-menu-main">
            <ul>
              <template v-for="(menu, index) in menuTree">
                <li :key="index" v-if="menu.childs && menu.childs.length > 0" :class="{ active: menu.active }"
                  tabindex="0" role="button" :title="menu.name" @click="switchMenu(menu)"
                  @keyup.enter="switchMenu(menu)" @keyup.space.prevent="switchMenu(menu)">
                  <i class="vc-menu-icon" :class="getMenuIcon(menu)"></i><span class="vc-menu-text">{{ menu.name }}</span>
                </li>
              </template>
            </ul>
          </div>
          <div class="vc-menu-sub" v-if="subMenus && subMenus.length > 0">
            <ul>
              <li class="title">{{ curMenuName }}</li>
              <!-- 业务分组渲染：把同一业务域的子菜单折叠到一个分组下 -->
              <template v-for="group in subMenuGroups">
                <li :key="'gh-' + group.key" class="group-header" @click.stop="toggleGroup(group.key)">
                  <i v-if="group.icon" :class="group.icon" class="group-icon"></i>
                  <span class="group-name">{{ group.name }}</span>
                  <i class="fa group-arrow"
                    :class="expandedGroups[group.key] === false ? 'fa-angle-right' : 'fa-angle-down'"></i>
                </li>
                <template v-if="expandedGroups[group.key] !== false">
                  <li v-for="item in group.items" :key="'gi-' + group.key + '-' + (item.mId || item.name)"
                    :class="['group-item', { active: item.active }]"
                    v-on:click="_gotoPage(item.href, item.name)">
                    {{ item.name }}
                  </li>
                </template>
              </template>
              <li class="sub-footer" @click="_closeSubMenu()"><i class="fa fa-dedent"></i></li>
            </ul>
          </div>
        </div>
      </el-aside>

      <!-- 主要内容区 -->
      <el-main class="app-main">
        <!-- 多标签页：单行不换行 -->
        <div class="tabs-wrap" v-if="visitedTabs.length > 0">
          <div class="tabs-list">
            <div
              v-for="tab in visitedTabs"
              :key="tab.path"
              :class="['tabs-item', { active: $route.path === tab.path }]"
              @click="goTab(tab)"
            >
              <span class="tabs-item-title">{{ tab.titleKey ? $t(tab.titleKey) : tab.title }}</span>
              <i class="el-icon-close tabs-item-close" @click.stop="removeTab(tab)" v-if="visitedTabs.length > 1"></i>
            </div>
          </div>
          <el-button type="text" size="mini" class="tabs-close-all" @click="closeAllTabs">
            {{ $t('layout.closeAllTabs') }}
          </el-button>
        </div>
        <router-view />
      </el-main>
    </el-container>
    <more-community ref="moreCommunity" />
    <view-menu-user-list ref="viewMenuUserModel" />
    <search-community-data-list ref="searchCommunityDataModel" />
  </el-container>
</template>

<script>
/* eslint-disable no-console */
import { _getMenuCatalog, getMenuTree, jumpToMall, jumpToIot } from '@/api/user/menuApi'
import { getStoreInfo } from "@/api/user/indexApi"
import { listSystemInfo } from '@/api/system/systemInfoManageApi'
import { deepCopy, setCurrentCommunity } from "@/utils/vc"
import { getCommunityName, _loadCommunityInfo } from '@/api/community/communityApi'
import moreCommunity from '@/components/community/moreCommunity.vue'
import viewMenuUserList from '@/components/system/viewMenuUserList.vue'
import searchCommunityDataList from '@/components/system/searchCommunityDataList.vue'
import { initSystem } from '@/api/util/vcApi'
import config from '@/conf/config'
import { groupSubMenus } from './menuGroupConfig'
import { getMenuIcon } from './menuIconConfig'

const MENU_GROUP_STORAGE_KEY = 'layout.menuGroup.expanded'

export default {
  name: 'Layout',
  data() {
    return {
      catalogs: [],
      menuTree: [],
      subMenus: [],
      menuWidth: 80,
      menuId: '',
      curMenuName: '',
      activeMenu: '',
      activeSubMenu: 'communityList',
      searchText: '',
      username: '',
      curCommunityName: '',
      communitys: [],
      storeInfo: {
        storeTypeCd: '',
        storeId: ''
      },
      systemInfo: {
        systemSimpleTitle: '',
        companyName: '',
        logoUrl: '',
        version: ''
      },
      visitedTabs: [], // 已打开的页面 { path, titleKey?, title? }
      subMenuGroups: [], // 当前 subMenus 按业务分组后的结果
      expandedGroups: {} // 每个分组的折叠状态 { groupKey: boolean }
    }
  },
  computed: {
    // 当前 catalog 下所有菜单组的所有子菜单汇总，用于跨菜单组合并展示
    allMenuPool() {
      const pool = []
      for (const m of this.menuTree || []) {
        if (m && Array.isArray(m.childs)) {
          for (const c of m.childs) {
            pool.push(c)
          }
        }
      }
      return pool
    }
  },
  watch: {
    $route: {
      handler(route) {
        if (!route.path || route.path === '/views/user/login' || route.path === '/login') return
        const path = route.path
        const exists = this.visitedTabs.some(t => t.path === path)
        if (!exists) {
          const info = this.getTabTitle(path, route.meta || {})
          if (info) this.visitedTabs.push({ path, ...info })
        }
      },
      immediate: true
    },
    subMenus: {
      handler(newVal) {
        // 按业务分组规则重新分组
        this.subMenuGroups = groupSubMenus(newVal || [], this.allMenuPool, this.curMenuName)
        // 初始化每个分组的折叠状态：优先用 localStorage 中持久化的值，否则默认展开
        for (const g of this.subMenuGroups) {
          if (!(g.key in this.expandedGroups)) {
            this.$set(this.expandedGroups, g.key, true)
          }
        }
      },
      immediate: true
    }
  },
  created() {
    let _user = JSON.parse(localStorage.getItem('user'));
    this.username = _user.name
    this.systemInfo.version = config.version
    this.getSystemInfo()
    this._loadStoreInfo()
    this.loadCatalogs()
    this.curCommunityName = getCommunityName()
    this.loadCommunity()
    // 恢复业务分组的折叠状态
    try {
      const saved = localStorage.getItem(MENU_GROUP_STORAGE_KEY)
      if (saved) {
        const parsed = JSON.parse(saved)
        if (parsed && typeof parsed === 'object') {
          this.expandedGroups = parsed
        }
      }
    } catch (e) {
      // 忽略解析失败
    }
    initSystem()
  },
  components: {
    moreCommunity,
    viewMenuUserList,
    searchCommunityDataList
  },
  methods: {
    // 左侧一级菜单图标：按菜单名映射语义化图标
    // 注册到 methods 是为了兼容 eslint-plugin-vue v6（其 no-unused-vars 不分析 template 块）
    getMenuIcon,
    // 标签页名称：仅当路由配置了 meta.title 或 meta.titleKey 时才展示该标签
    getTabTitle(path, meta) {
      if (path === '/views/index/index' || path === '/') {
        return { titleKey: 'layout.home' }
      }
      const m = meta || {}
      if (m.title) return { title: m.title }
      if (m.titleKey) return { titleKey: m.titleKey }
      return null
    },
    goTab(tab) {
      if (this.$route.path === tab.path) return
      this.$router.push(tab.path).catch(() => {})
    },
    removeTab(tab) {
      const list = this.visitedTabs.filter(t => t.path !== tab.path)
      this.visitedTabs = list
      if (this.$route.path === tab.path) {
        const next = list.length ? list[list.length - 1] : { path: '/views/index/index' }
        this.$router.push(next.path).catch(() => {})
      }
    },
    closeAllTabs() {
      this.visitedTabs = []
      this.$router.push('/views/index/index').catch(() => {})
    },
    // 切换业务分组的展开/折叠状态
    toggleGroup(groupKey) {
      this.$set(this.expandedGroups, groupKey, !this.expandedGroups[groupKey])
      try {
        localStorage.setItem(MENU_GROUP_STORAGE_KEY, JSON.stringify(this.expandedGroups))
      } catch (e) {
        // 忽略持久化失败（如隐私模式）
      }
    },
    async getSystemInfo() {
      const { data } = await listSystemInfo({ page: 1, row: 1 });
      this.systemInfo.systemSimpleTitle = data[0].systemSimpleTitle
      this.systemInfo.companyName = data[0].companyName
      this.systemInfo.logoUrl = data[0].logoUrl
    },
    async loadCommunity() {
      const { communitys } = await _loadCommunityInfo()
      this.communitys = communitys
      this.curCommunityName = getCommunityName()

    },
    async _loadStoreInfo() {
      this.loading = true
      try {
        const res = await getStoreInfo()
        deepCopy(res, this.storeInfo);
      } catch (error) {
        console.error('登录失败：', error)
      } finally {
        this.loading = false
      }

    },
    async loadCatalogs() {
      this.loading = true
      try {
        const res = await _getMenuCatalog()
        if (res.code != 0) {
          return;
        }
        this.catalogs = res.data;
        if (this.catalogs && this.catalogs.length > 0) {
          this._changeMenuCatalog(this.catalogs[0])
        }
      } catch (error) {
        console.error('登录失败：', error)

      } finally {
        this.loading = false
      }
    },
    _changeMenuCatalog(_catalog, _isJump) {
      this.activeMenu = _catalog.caId;
      if (this._showModelDiv(_catalog)) {
        return;
      }
      if (_catalog.caId === '1') {
        this.$router.push('/#/pages/mall/product');
      }
      if (_catalog.url == 'IOT') {
        jumpToIot('/');
        return;
      }
      if (_catalog.url == 'MALL') {
        //获取用户名
        jumpToMall('/');
        return;
      }
      console.log(_catalog)
      if (_catalog.url != '#' && _isJump) {
        this._gotoPage(_catalog.url, _catalog.name)
        //return;
      }
      this.loadMenuTree(_catalog)
    },

    handleCommand(command) {
      if (command === 'logout') {
        // 处理退出登录

        localStorage.removeItem('token')
        localStorage.clear();
        this.$router.push('/login')
      } else if (command === 'zh' || command === 'en') {
        // 切换语言
        this.$i18n.locale = command
        localStorage.setItem('language', command)
      }
    },
    changeCommunity(community) {
      if (community == 'moreCommunity') {
        this.$refs.moreCommunity.open()
        return
      }
      setCurrentCommunity(community);
      this.curCommunityName = getCommunityName()
      window.location.href = "/"
    },
    handleMenuSelect(index) {
      // 处理菜单选择
      this.$router.push({ name: index })
    },
    loadMenuTree(_catalog) {
      getMenuTree(_catalog).then(res => {
        let _menus = res.data;
        _menus.sort(function (a, b) {
          return a.seq - b.seq
        });
        this.menuTree = _menus;
      })
    },
    switchMenu(_menu) {
      //设置菜单ID
      this.menuId = _menu.id;
      this.menuTree = this.refreshMenuActive(this.menuTree, _menu.id);
      this.subMenus = _menu.childs;
      console.log(this.subMenus)
      this.curMenuName = _menu.name;

      if (!_menu.childs || _menu.childs.length < 1) {
        return;
      }
      //选中第一个
      this._gotoPage(_menu.childs[0].href, _menu.childs[0].name);
      //vc._fix_height()
    },
    refreshMenuActive(jsonArray, _id) {
      for (let menuIndex = 0; menuIndex < jsonArray.length; menuIndex++) {
        if (jsonArray[menuIndex].childs) {
          let _childs = jsonArray[menuIndex].childs;
          _childs.sort(function (_child, _newChild) {
            return _child.seq - _newChild.seq
          });
          jsonArray[menuIndex].childs = _childs;
        }

        if (_id === jsonArray[menuIndex].id) {
          //如果当前本身是打开状态，说明 需要关闭
          jsonArray[menuIndex].active = true;
          continue;
        }
        jsonArray[menuIndex].active = false;
      }
      return jsonArray;
    },
    _setSelectedMenusChild(_href) {
      for (var menuIndex = 0; menuIndex < this.menuTree.length; menuIndex++) {
        if (this.menuTree[menuIndex].childs) {
          var _childs = this.menuTree[menuIndex].childs;
          for (var childIndex = 0; childIndex < _childs.length; childIndex++) {
            if (_href == _childs[childIndex].href) {
              this.menuTree[menuIndex].childs[childIndex].active = true;
            } else {
              this.menuTree[menuIndex].childs[childIndex].active = false;
            }
          }
        }
      }
      this.$forceUpdate();
    },
    _gotoPage(_href, _tabName) {
      console.log(_href, _tabName)
      // 子菜单默认选中
      this._setSelectedMenusChild(_href);
      if (_href.indexOf('.html') > -1) {
        window.open(_href, '_blank')
        return
      }
      if (_href.indexOf('/#/') > -1) {
        _href = _href.replace('/#/', '/')
      }

      this.$router.push(_href).catch(err => {
        // 忽略重复导航错误
        if (err.name !== 'NavigationDuplicated') {
          throw err
        }
      })
    },
    _showModelDiv: function (_catalog) {
      console.log(_catalog)
      if (_catalog.url.startsWith('?')) {
        let _modelName = _catalog.url.substring(1, _catalog.url.length);
        this.$refs[_modelName].open()
        return true;
      }
      return false;
    },
    _toIndex() {
      location.href = '/'
    },
    _closeSubMenu() {
      this.subMenus = []
      this.curMenuName = ''
    }

  }
}
</script>

<style lang="scss" scoped>
.app-wrapper {
  height: 100vh;
}

.app-header {
  background-color: var(--ds-primary);
  color: #fff;
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: var(--ds-shadow-md);
}

.header-left {
  display: flex;
  align-items: center;
}

.logo {
  width: 100px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 22px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
  letter-spacing: 0.5px;
  font-family: var(--ds-font-family-cn);
}

.header-menu {
  border: none;
}

.header-right {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.margin-left {
  margin-left: 15px;
  color: rgba(255, 255, 255, 0.85);
  font-size: var(--ds-font-size-sm);
}

.user-info {
  color: #fff;
  cursor: pointer;
  font-weight: 500;
}

.app-aside {
  width: auto;
}

.menu-wrapper {
  height: 100%;
}

.el-menu-vertical {
  border: none;
}

.el-menu-vertical:not(.el-menu--collapse) {
  width: 200px;
}

.app-main {
  background-color: var(--ds-gray-100);
  height: calc(100vh - 60px);
  padding: 0px;
}

.tabs-wrap {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  background: #fff;
  border-bottom: 1px solid var(--ds-gray-300);
  gap: 8px;
}
.tabs-list {
  display: flex;
  flex-wrap: nowrap;
  gap: 4px;
  flex: 1;
  min-width: 0;
  overflow-x: auto;
}
.tabs-item {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  font-size: 13px;
  border-radius: var(--ds-radius-sm);
  cursor: pointer;
  color: var(--ds-gray-600);
  background: var(--ds-gray-100);
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: background-color var(--ds-transition-fast),
              color var(--ds-transition-fast);
}
.tabs-item:hover {
  color: var(--ds-primary);
  background: rgba(var(--ds-primary-rgb), 0.08);
}
.tabs-item.active {
  color: #fff;
  background: var(--ds-primary);
  font-weight: 500;
}
.tabs-item-title {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tabs-item-close {
  margin-left: 6px;
  font-size: 12px;
  opacity: 0.7;
}
.tabs-item-close:hover {
  opacity: 1;
  color: var(--ds-danger);
}
.tabs-close-all {
  flex-shrink: 0;
  padding: 4px 8px;
}

:deep(.el-menu--horizontal) {
  border-bottom: none;
}

:deep(.el-menu-item) {
  height: 50px;
  line-height: 50px;
  font-weight: 500;
}

:deep(.el-menu-item:hover) {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

:deep(.el-menu-item.is-active) {
  background-color: rgba(255, 255, 255, 0.15) !important;
  color: #fff !important;
  border-bottom: 2px solid rgba(255, 255, 255, 0.8);
}

:deep(.el-submenu__title) {
  height: 50px;
  line-height: 50px;
  padding: 0 20px !important;
}

:deep(.el-menu--collapse) {
  width: 64px;
}

:deep(.el-menu--collapse .el-submenu__title) {
  padding: 0 !important;
  text-align: center;
}

:deep(.el-menu--collapse .el-submenu__title i) {
  margin: 0;
  font-size: 20px;
}

:deep(.el-menu--popup) {
  min-width: 200px;
  background-color: var(--ds-primary) !important;
  border-radius: var(--ds-radius-sm);
}

:deep(.el-menu--popup .el-menu-item) {
  background-color: var(--ds-primary);
  color: rgba(255, 255, 255, 0.85);
}

:deep(.el-menu--popup .el-menu-item:hover) {
  background-color: var(--ds-primary-light);
  color: #fff;
}

:deep(.el-menu--popup .el-menu-item.is-active) {
  color: #fff;
  font-weight: 600;
}

:deep(.el-dropdown-menu__item:hover) {
  background-color: rgba(var(--ds-primary-rgb), 0.08) !important;
  color: var(--ds-primary) !important;
}

.vc-menu {
  border-right: none;

  .vc-menu-main {
    background-color: var(--ds-primary);
    color: rgba(255, 255, 255, 0.7);
    text-align: center;
    width: 80px;
    font-size: 14px;
    height: calc(100vh - 60px);
    overflow-x: hidden;
    overflow-y: scroll;
    scrollbar-width: none;

    .active {
      background-color: var(--ds-primary-light);
      color: #FFFFFF;
    }
  }

  /* 一级菜单图标：统一尺寸、居中、与文字基线对齐 */
  .vc-menu-icon {
    display: inline-block;
    width: 20px;
    text-align: center;
    font-size: 16px;
    line-height: 1;
    vertical-align: middle;
    margin-right: 4px;
    flex-shrink: 0;
    transition: color var(--ds-transition-fast),
                transform var(--ds-transition-fast);
  }

  /* 一级菜单文字：超出省略，避免长名称撑破 80px 栏宽 */
  .vc-menu-text {
    display: inline-block;
    max-width: 48px;
    vertical-align: middle;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 1;
  }

  .vc-menu-main::-webkit-scrollbar {
    display: none;
  }

  ul {
    padding-inline-start: 0px;
    margin: 0;
    padding: 0;
  }

  li {
    margin: 0;
    padding: 0;
  }
}

.moreCommunity {
  font-weight: 600;
  color: var(--ds-gray-700);
  font-size: 12px;
}

.vc-menu-main ul li {
  height: 45px;
  line-height: 45px;
  cursor: pointer;
  list-style-type: none;
  position: relative;
  transition: background-color var(--ds-transition-fast),
              color var(--ds-transition-fast);
}

.vc-menu-main ul li:hover {
  background-color: var(--ds-primary-light);
  color: #FFFFFF;
}

.vc-menu-main ul li:hover .vc-menu-icon {
  color: #FFFFFF;
  transform: scale(1.08);
}

/* 激活态：左侧 3px 高亮指示条 + 强调色图标 */
.vc-menu-main ul li.active {
  color: #FFFFFF;
  font-weight: 500;
}

.vc-menu-main ul li.active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background-color: var(--ds-info);
}

.vc-menu-main ul li.active .vc-menu-icon {
  color: var(--ds-info);
}

/* 键盘焦点可见性 */
.vc-menu-main ul li:focus {
  outline: none;
}

.vc-menu-main ul li:focus-visible {
  outline: 2px solid var(--ds-info);
  outline-offset: -2px;
}

.vc-menu-main ul li.title {
  color: #FFFFFF;
  height: 60px;
  font-size: 20px;
  line-height: 60px;
  font-family: var(--ds-font-family-cn);
}

.vc-menu-main ul li.title a {
  text-decoration: none;
  cursor: pointer;
  color: #FFFFFF;
}

.vc-menu-sub {
  background-color: #FFFFFF;
  color: var(--ds-gray-700);
  text-align: start;
  width: 110px;
  font-size: 14px;
  height: calc(100vh - 60px);
  overflow-x: hidden;
  overflow-y: scroll;
  scrollbar-width: none;
}

.vc-menu-sub::-webkit-scrollbar {
  display: none;
}

.vc-menu-sub .active {
  background-color: rgba(var(--ds-primary-rgb), 0.1);
  color: var(--ds-primary);
  font-weight: 500;
}


.vc-menu-sub ul li {
  height: 40px;
  line-height: 40px;
  padding-left: 15px;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  transition: background-color var(--ds-transition-fast),
              color var(--ds-transition-fast);
}

.vc-menu-sub ul li.title {
  color: var(--ds-gray-700);
  height: 40px;
  font-size: var(--ds-font-size-sm);
  line-height: 40px;
  text-align: center;
  padding-left: 0px;
  border-bottom: 1px solid var(--ds-gray-300);
  margin-bottom: 10px;
  font-weight: 600;
}

.vc-menu-sub ul li:hover {
  background-color: rgba(var(--ds-primary-rgb), 0.08);
  color: var(--ds-primary);
}

.vc-menu-sub ul li.sub-footer {
  background-color: var(--ds-gray-100);
  text-align: center;
  width: 110px;
  border-top: 1px solid var(--ds-gray-300);
  position: absolute;
  bottom: 0;
  left: 0;
}

/* 业务分组标题（可点击折叠） */
.vc-menu-sub ul li.group-header {
  height: 36px;
  line-height: 36px;
  padding-left: 12px;
  padding-right: 10px;
  cursor: pointer;
  background-color: rgba(var(--ds-primary-rgb), 0.05);
  color: var(--ds-primary);
  font-weight: 600;
  font-size: 13px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(var(--ds-primary-rgb), 0.08);
  user-select: none;
  transition: background-color var(--ds-transition-fast);
}

.vc-menu-sub ul li.group-header:hover {
  background-color: rgba(var(--ds-primary-rgb), 0.12);
}

.vc-menu-sub ul li.group-header .group-icon {
  margin-right: 6px;
  font-size: 13px;
}

.vc-menu-sub ul li.group-header .group-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.vc-menu-sub ul li.group-header .group-arrow {
  font-size: 12px;
  color: var(--ds-primary);
  opacity: 0.85;
}

/* 业务分组内的子项（缩进 + 字号略小） */
.vc-menu-sub ul li.group-item {
  padding-left: 28px !important;
  font-size: 13px;
  color: var(--ds-gray-700);
}

.vc-menu-sub ul li.group-item.active {
  background-color: rgba(var(--ds-primary-rgb), 0.1);
  color: var(--ds-primary);
  font-weight: 500;
}

.vc-menu-sub ul li.group-item:hover {
  background-color: rgba(var(--ds-primary-rgb), 0.08);
  color: var(--ds-primary);
}
</style>